import { Chip, Tooltip, Typography } from "@mui/material";
import { digitalClock } from "@ssf/play-components";
import { Information } from "mdi-material-ui";
import { useTranslation } from "react-i18next";

import { useTournamentClock } from "../lib/index.js";

/** 10 hours */
const breakpoint = 10 * 60 * 60 * 1000;

export const TournamentClock = (
  props: Parameters<typeof useTournamentClock>[0],
) => {
  const { t } = useTranslation("TournamentClock");
  const [status, { startDiff, endDiff }] = useTournamentClock(props);

  if (status === "completed") {
    return (
      <Tooltip title={t("completedTooltip")}>
        <Chip color="info" icon={<Information />} label={t("completed")} />
      </Tooltip>
    );
  }
  if (status === "running") {
    return (
      <Typography variant="body2">
        {t("endsIn", { time: digitalClock(endDiff) })}
      </Typography>
    );
  }

  if (status === "pending") {
    if (startDiff < breakpoint) {
      return (
        <Typography variant="body2">
          {t("startsIn", { time: digitalClock(startDiff) })}
        </Typography>
      );
    }

    return (
      <Typography variant="body2" whiteSpace="nowrap">
        {t("startsAt", {
          datetime: new Date(props.start)
            .toLocaleString("sv-SE")
            .replace(/:00$/, ""),
        })}
      </Typography>
    );
  }

  return null;
};
